/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-observers */
import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { alias } from '@ember/object/computed';
import { observes } from '@ember-decorators/object';

export default class PeriodsForDate extends Helper {
  @service
  dates;

  // Recompute if the timetable structures change.
  @alias('dates.structures')
  structures;

  @observes('structures', 'structures.@each.effectiveFrom')
  _watchStructures() {
    this.recompute();
  }

  compute(params) {
    return this.dates.dayForDate(params[0]);
  }
}
